import { forEach } from 'lodash-es';

export const useDocumentStore = () => {
  const { app } = useGeneralStore(); 
  const document = useState<any>('document',() => ({}));
  const archive = useState<any>('archive',() => ([]));
  const attachments = useState<any>('attachments',() => ([]));
  const currentModel = useState<any>('currentModel',() => 'documents');
  const dynamicFormSchema = useState('dynamicFormSchema');

  const setCurrentModel = (val:string) => currentModel.value=val;
  const setDocument= (doc: any) => document.value = doc;

  const fetchDocumentSchema = async () => {
    if(!currentModel.value) return;

    try{
      const {data: dynamicFormData } = await useTenantFetch(`/api/dynamic_form`, { 
        query: { model: currentModel.value },
      });

      dynamicFormSchema.value = dynamicFormData.value;
    }catch(err){
      log('error fetching schema',err);
    }
    return;

  }
  const fetchDocument = async (id?:string) => {
    try{
      await fetchDocumentSchema();
      try{
        const { data } = await useTenantFetch(`/api/${currentModel.value}/${id || document.value._id}`,{
          sort: { insert_date: 'desc'}
        });
        if((data.value as any[]).length){
          document.value = (data.value as any[])[0];
          const { setName, setId } = useBreadcrumb();
          setName(`${document.value.code} - ${document.value.title}`);
          setId(`${document.value._id}`);
          await fetchArchive();
        }
      }catch(err){
        log('Error fetching document',err);
      }
    }catch(err){
      log(err)
    }
  };
  const fetchArchive = async () => {
    archive.value = [];
    attachments.value = [];
    try{
      const params:any = { query: { where: { document_id: document.value._id }, sort: { revision: "desc", version: "desc" }}};
      if(currentModel.value=='public_documents'){
        params.query.where.revision = document.value.revision;
      }
      const { data }  = await useTenantFetch('/api/archive', params);
      forEach(data.value as any[], (item: any) => {
        if(item.type === 'attachment'){
          attachments.value.push(item);
        }else{
          archive.value.push(item);
        }
      });
    }catch(err){
      console.log('Error during archive fetch',err);
    }
  };

  return {
    document,
    archive,
    setCurrentModel,
    setDocument,
    fetchDocumentSchema,
    fetchDocument,
    fetchArchive,
  };
};